import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavbarComponent } from '@components/navbar/navbar.component';
import { SidebarComponent } from '@components/sidebar/sidebar.component';
import { ToastComponent } from '@components/toast/toast.component';
import { RouterOutlet } from '@angular/router';
import { ModalComponent } from '@shared/components/modal/modal.component';

@Component({
    selector: 'app-auth-layout',
    standalone: true,
    imports: [NavbarComponent, SidebarComponent, RouterOutlet, ToastComponent, ModalComponent],
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss'],
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
    sidebarOpened = false;
    isMobile = false;

    private resizeListener = () => this.checkMobile();

    ngOnInit() {
        this.checkMobile();
        window.addEventListener('resize', this.resizeListener);
    }

    ngOnDestroy() {
        window.removeEventListener('resize', this.resizeListener);
    }

    checkMobile() {
        this.isMobile = window.innerWidth < 1024;
        if (!this.isMobile) {
            this.sidebarOpened = false;
        }
    }

    toggleSidebar() {
        this.sidebarOpened = !this.sidebarOpened;
    }

    closeSidebar() {
        if (this.isMobile && this.sidebarOpened) {
            this.sidebarOpened = false;
        }
    }
}
